/**
 *  [2021] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: aws,resource
 * note:
 *  - AWSのリソースにアクセスするためのエンドポイント情報等を保持する
 *  - プロジェクトごとに生成されているsalt文字列を保持する
 * sample:
 *  -
 * :ZNOTE:
 */

import {getAppParams} from '@zettant/commonUtils';

const params: any = getAppParams();
const awsResources = params.endpoint;
const salt = params.salt;

export {awsResources, salt};
export default {awsResources, salt};
